import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

export const ContentHeaderUnifiedQuery: GraphQLTaggedNode = graphql`
	query ContentHeaderUnifiedQuery(
		$contentId: ID!
		$spaceKey: String
		$versionOverride: Int
		$embeddedContentRender: String
		$limit: Int
		$useNewContentTopper: Boolean = false
		$includeDevDocsBylineConnection: Boolean = false
		$useObjectHeaderFragment: Boolean = false
		$useEditButtonFragment: Boolean = false
		$useAccessButtonFragment: Boolean = false
		$includePublicLink: Boolean = false
		$includeClassification: Boolean = false
		$useClassificationLevelV2: Boolean = false
		$status: [String]
	) @raw_response_type {
		content(
			id: $contentId
			version: $versionOverride
			embeddedContentRender: $embeddedContentRender
			status: $status
		) {
			nodes {
				id
				...EditContentButton_content
					@alias(as: "editContentButton")
					@include(if: $useEditButtonFragment)
				...useShareAndRestrictButtonData_content
					@alias(as: "shareAndRestrictButtonData")
					@include(if: $useAccessButtonFragment)
				...ContentTypesHeader_content
					@alias(as: "contentTypesHeader")
					@include(if: $useObjectHeaderFragment)
				...BylineClassification_content
					@arguments(useClassificationLevelV2: $useClassificationLevelV2)
					@alias(as: "bylineClassificationFragment")
					@include(if: $includeClassification)
				type
				subType
				title
				status
				ancestors @include(if: $includeDevDocsBylineConnection) {
					id
					title
					type
					subType
					history {
						createdBy {
							displayName
						}
					}
					properties(keys: ["devdocsProperties", "smartFolderProperties"]) {
						nodes {
							id
							key
							value
						}
					}
				}
				appearancePublished: properties(key: "content-appearance-published") {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
				history {
					createdDate
					createdBy {
						type
						displayName
						... on KnownUser {
							accountId
						}
						profilePicture {
							path
						}
					}
					ownedBy {
						type
						displayName
						... on KnownUser {
							accountId
						}
						profilePicture {
							path
						}
					}
					lastOwnedBy {
						type
						displayName
						... on KnownUser {
							accountId
						}
						profilePicture {
							path
						}
					}
				}
				emojiTitlePublished: properties(key: "emoji-title-published") {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
				pageTitlePublished: properties(key: "page-title-property-published")
					@include(if: $useNewContentTopper) {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
				properties(key: "editor") {
					nodes {
						id
						key
						value
					}
				}
				space {
					id
					name
					homepageId
				}
				version {
					message
					by {
						type
						displayName
						... on KnownUser {
							accountId
						}
						profilePicture {
							path
						}
					}
					friendlyWhen
					when
					number
					contentTypeModified
				}
				contentProperties {
					latest {
						generatedBy
					}
				}
				metadata {
					sourceTemplateEntityId
					lastModifiedDate
					frontend {
						fabricEditorSupported
						coverPictureWidth @include(if: $useNewContentTopper)
					}
				}
			}
		}
		publicLinkPage(pageId: $contentId) @include(if: $includePublicLink) {
			pageId
			pageStatus
			accessType
		}
		contentContributors(id: $contentId, limit: $limit) {
			count
			isCurrentUserContributor
			isOwnerContributor
			nodes {
				type
				displayName
				... on KnownUser {
					accountId
				}
				profilePicture {
					path
				}
			}
		}
		space(key: $spaceKey) {
			id
			theme {
				themeKey
			}
			lookAndFeel {
				headings {
					key
					value
				}
				content {
					header {
						background
						backgroundAttachment
						backgroundBlendMode
						backgroundClip
						backgroundColor
						backgroundImage
						backgroundOrigin
						backgroundPosition
						backgroundRepeat
						backgroundSize
						borderRadius
						padding
					}
				}
			}
		}
	}
`;
